import React from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import KanbanBoard from "../components/kanban/kanban-board";
import Header from "../components/header/header";
import Footer from "../components/footer/footer";
import { useAuth } from "../lib/AuthContext";

const queryClient = new QueryClient(); // ✅ Initialize React Query Client

const Sales: React.FC = () => {
  const auth = useAuth();
  const hasCRM = auth?.currentUser?.module_crm_plan;

  return (
    <div className="hidden flex-col md:flex w-full sales-dashboard">
      <Header />

      <div className="flex-1 space-y-0 p-8 pt-6  flex flex-col mt-10 w-full">
        <div className="border border-gray-300 rounded-lg bg-white dark:bg-gray-900 p-4 mt-6 font-normal text-sm text-slate-600">
          <h1 className="text-2xl font-bold mb-4 border-b pb-4 text-accent">
            Sales Pipeline
          </h1>

          {hasCRM && (
            <QueryClientProvider client={queryClient}>
              <KanbanBoard />
            </QueryClientProvider>
          )}
        </div>
      </div>

      {/* Footer */}
      <div className="footer-section">
        <Footer />
      </div>
    </div>
  );
};

export default Sales;
